const badInternalLinks = [
  process.env.GATSBY_WP_BASE_BLOG,
  process.env.GATSBY_WP_BASE_PAGES,
];
function isFile(pathname) {
  return pathname.split("/").pop().indexOf(".") > -1;
}
export function replaceLinks(link) {
  if (
    link &&
    typeof link === "string" &&
    badInternalLinks.find((l) => link.includes(l))
  ) {
    const urlObj = new URL(link);
    if (!isFile(link)) {
      return urlObj.href.replace(urlObj.origin, "");
    }
  }

  return link;
}

const badImagehrefs = [
  "https://lacework.com",
  "https://www.lacework.com",
  "http://lacework.com",
  "http://www.lacework.com",
  "http://lacework.local",
];

export function replaceSrc(src) {
  if (src && badImagehrefs.find((l) => src.includes(l))) {
    const urlObj = new URL(src);
    return urlObj.href.replace(urlObj.origin, process.env.GATSBY_WP_BASE_BLOG);
  }

  return src;
}
